const constants = {
  urlBack: process.env.REACT_APP_BACK,
  // Dominio de cloud functions
  cfunctionDomain: process.env.REACT_APP_CFUNCTION_DOMAIN,
  imgNewContact:
    "https://chazkistorage.blob.core.windows.net/resources/new_contact.svg",
};

// Keycloak mode (REACT_APP_AUTH_USERINFO_URL set): REACT_APP_AUTH_PROVIDER is the realm issuer and
// user info comes from the backend /me, which keeps the legacy claims (permissions, regionCountry...).
const authProvider = process.env.REACT_APP_AUTH_PROVIDER || "";
const backendUserInfoUrl = process.env.REACT_APP_AUTH_USERINFO_URL;
const keycloakIssuer = authProvider.replace(/\/+$/, "");
const keycloakMetadata = backendUserInfoUrl
  ? {
      issuer: keycloakIssuer,
      authorization_endpoint: `${keycloakIssuer}/protocol/openid-connect/auth`,
      token_endpoint: `${keycloakIssuer}/protocol/openid-connect/token`,
      end_session_endpoint: `${keycloakIssuer}/protocol/openid-connect/logout`,
      jwks_uri: `${keycloakIssuer}/protocol/openid-connect/certs`,
      userinfo_endpoint: backendUserInfoUrl,
    }
  : undefined;

const constantsOauth = {
  stsAuthority: process.env.REACT_APP_AUTH_PROVIDER,
  clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
  clientRoot: process.env.REACT_APP_URL,
  clientScope: process.env.REACT_APP_AUTH_SCOPE || "openid profile email role",
  apiRoot: `${process.env.REACT_APP_AUTH_PROVIDER}/token`,
  userInfoUrl: backendUserInfoUrl || `${authProvider}me`,
  metadata: keycloakMetadata,
};

export { constants, constantsOauth };
